<template>
	<div style="margin-bottom: 2rem">
		<h2>
			<Label :characteristic="item.item"/>
			<template v-if="getSupplements(item)">({{ getSupplements(item) }})</template>
		</h2>
		<Edit
			:item="item"
			:experience-config="experienceConfig"
			:self-assessment-config="selfAssessmentConfig"
			:education-config="educationConfig"
			:type="type"
			class="pl-5"
			@change="onChange"
		/>
	</div>
</template>

<script>
import Label from "@/vue/characteristic/Label.vue";
import {mapState} from "vuex";
import Edit from "@/vue/characteristic/addition/Edit.vue";
import {getAsList} from "@/helper/characteristic/Supplement";

export default {
	components: {
		Label,
		Edit,
	},

	props: {
		item: {
			type: Object,
			required: false,
		},
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('characteristic/addition/matrix/fan', [
			'type',
			'experienceConfig',
			'selfAssessmentConfig',
			'educationConfig',
		]),
	},

	methods: {
		getSupplements (item)
		{
			if (!item.supplements)
			{
				return undefined;
			}

			return getAsList(item.supplements);
		},
		onChange (data)
		{
			this.$set(this.item, 'experience', data.experience);
			this.$set(this.item, 'selfAssessment', data.selfAssessment);
			this.$set(this.item, 'educationsFinished', data.educationsFinished);
			this.$set(this.item, 'educationsUnfinished', data.educationsUnfinished);
		}
	}
}
</script>
